import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@lms/ui/dropdown-menu';
import { EllipsisVerticalIcon, TrashIcon } from 'lucide-react';
import { useTranslations } from 'use-intl';
import { removeStudent } from '@/features/groups/groups-api';

export default function OverflowMenu({
  id,
  onRemoved,
}: {
  id: number;
  onRemoved: () => void;
}) {
  const t = useTranslations('admin');

  const handleRemove = async () => {
    await removeStudent(id);
    onRemoved();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <EllipsisVerticalIcon />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem className="text-destructive" onClick={handleRemove}>
          <TrashIcon className="mr-2 h-4 w-4" />
          {t('remove', { what: '' }).trim()}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
